import React from "react";
import TableCell from "@mui/material/TableCell";
import { IconButton, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import SaveIcon from "@mui/icons-material/Save";

export default function Actions({
  editIndex,
  index,
  validate,
  row,
  options,
  setSaved,
  rowCopy,
}) {
  return (
    <TableCell
      sx={(theme) => ({
        minWidth: "170px",
        width: "100%",
        backgroundColor: "white",
        [theme.breakpoints.up("md")]: {
          position: "sticky",
          right: 0,
        },
        padding: '0px 16px',
        borderLeft: "dotted 1px gray !important",
      })}
      component="th"
      scope="row"
    >
      {editIndex.rowIndex === index && options?.save && (
        <Tooltip title="Save">
          <IconButton
            id="button"
            onClick={(e) => {
              e.stopPropagation();

              validate(row);
            }}
          >
            <SaveIcon />
          </IconButton>
        </Tooltip>
      )}

      {options?.delete && (
        <Tooltip title="Delete">
          <IconButton
            id="button"
            onClick={(e) => {
              e.stopPropagation();

              setSaved(true);

              options.delete(row);
            }}
          >
            <DeleteIcon sx={{ color: "error.light" }} />
          </IconButton>
        </Tooltip>
      )}

      {options?.open && (
        <Tooltip title="Open">
          <IconButton onClick={() => options?.open?.(rowCopy, row)}>
            <OpenInNewIcon sx={{ color: "primary.light" }} />
          </IconButton>
        </Tooltip>
      )}
    </TableCell>
  );
}
